export const MIN_PORTRAIT_WIDTH = 802;
export const MIN_LANDSCAPE_WIDTH = 1190;
export const MAX_PORTRAIT_WIDTH = MIN_LANDSCAPE_WIDTH - 1;

// problemRegion should be at least 65% of the screen width (ceiling of 762/1190)
// when in landscape mode to ensure that the problem region is at least 762px wide
// Note: 762 comes from PROBLEM_WIDTH in problemCanvasConstants.ts
export const LANDSCAPE_PROBLEM_WIDTH_PERCENTAGE = 65;
export const LANDSCAPE_SQUARES_WIDTH_PERCENTAGE =
  100 - LANDSCAPE_PROBLEM_WIDTH_PERCENTAGE;

export const GRAY = '#7B7B7B';
export const FLOATER_BLUE_BACKGROUND = '#33a4c6';
export const LABEL_AND_SQUARES_FIRST_BACKCOLOR = '#e9e9e9';
export const LABEL_AND_SQUARES_SECOND_BACKCOLOR = '#f8f8f8';

export const POINTS_LABEL_SIZE = 14;
export const POINTS_LABEL_FONT_FAMILY = "'Inter', Arial, sans-serif";
export const POINTS_LABEL_FONT = `${POINTS_LABEL_SIZE}px ${POINTS_LABEL_FONT_FAMILY}`;
export const POINTS_NUMBER_SIZE_LANDSCAPE = 24;
export const POINTS_NUMBER_SIZE_PORTRAIT = 20;
export const POINTS_NUMBER_SIZE_MOBILE = 16;

export const RED = 'rgb(241, 98, 99)';
export const YELLOW = 'rgb(232, 219, 60)';
export const GREEN = 'rgb(116, 192, 81)';
export const SILVER = 'rgb(192, 192, 192)';
export const SELECTED_BLUE = '#33a4c6';

export type Layout = 'mobile' | 'portrait' | 'landscape';

export const BOX_SHADOW = '2px 2px 0 rgb(185, 185, 185)';
export const BOX_SHADOW_REGION = '2px 2px 6px';
export const LIST_ITEM_COLOR = '#337ab7';

export const BANNER_HEIGHT = 53;
export const BOTTOM_BANNER_HEIGHT = 40;
export const EXAM_BUTTONS_HEIGHT = 46;
export const WELCOME_STRIP_HEIGHT = 30;

export const MAX_LANDSCAPE_BANNER_WORK_NAME_WIDTH = 500;
export const MAX_PORTRAIT_BANNER_WORK_NAME_WIDTH = 280;
export const MAX_MOBILE_BANNER_WORK_NAME_WIDTH = 150;
export const MAX_STUDENT_NAME_AND_CLASS_WIDTH = 220;

export const MOBILE_MARGIN_PX = 10;
export const MOBILE_MARGIN = `${MOBILE_MARGIN_PX}px`;

export const TEXT_COLOR = '#7b7b7b';

export const REGION_LABEL_TEXT_COLOR = 'rgb(100, 100, 100)';

export const GETTING_STARTED_VIDEO_URL =
  'https://sites.google.com/frontporch.com/gmm-student-tutorials/video-tutorials/how-does-get-more-math-work';
